<!--  -->
<template>
  <div class="main">
    <!-- 标题  -->
    <p class="title-Individual-center">
      <span>精彩活动</span>
      <i class="el-icon-arrow-right"></i>
      <span class="span-Individual-center">车险</span>
    </p>
    <!-- 主体 -->
    <div class="Core-body">
      <!-- 主体内容 -->
      <div class="Main-body">
        <!-- 切换 -->
        <div class="Toggle">
          <p
            v-for="(item, index) in selectArr"
            :key="index"
            :class="select == item.id ? 'select-p' : ''"
            @click="handelSelect(item.id)"
          >
            {{ item.name }}
          </p>
        </div>
        <!-- 活动时间 -->
        <p class="Events" v-if="select == '0'">
          活动时间：{{ formatDateOnly(Individual.startTime) }} -
          {{ formatDateOnly(Individual.endTime) }}
        </p>
        <p class="Events" v-else>
          活动时间：{{ formatDateOnly(GroupBuying.startTime) }} -
          {{ formatDateOnly(GroupBuying.endTime) }}
        </p>
        <!-- 活动内容 -->
        <div class="ActivityCon">
          活动内容：
          <div
            class="EventsCon"
            v-if="select == '0'"
            v-html="Individual.content"
          ></div>
          <div class="EventsCon" v-else v-html="GroupBuying.content"></div>
        </div>
        <!-- 表单 -->
        <div class="form-body">
          <Attend :select="select" :Reservation="Reservation"></Attend>
        </div>
        <!-- 底部按钮
          <div class="btm-button">
            <p >立即预约</p> 
          </div> -->
      </div>
    </div>
  </div>
</template>

<script>
import { homePageGetCarSafeActivityInfo } from "../../../../assets/api/indexl";
import Attend from "./components/Attend.vue";
export default {
  components: {
    Attend,
  },
  data() {
    return {
      selectArr: [
        { name: "个人活动", id: "0" },
        { name: "拼团活动", id: "1" },
      ], // 模块切换 数据
      select: "0", // 筛选
      Reservation: "0", //是否开启预约
      GroupBuying: {}, // 拼团活动信息
      Individual: {}, //个人活动信息
    };
  },
  created() {
    this.homePageGetCarSafeActivityInfo(); //个人，企业首页获取车险活动信息
  },
  mounted() {},
  destroyed() {},
  methods: {
    formatDateOnly(val) {
      if (!val) return "";
      const text = String(val);
      if (text.includes(" ")) return text.split(" ")[0];
      if (text.includes("T")) return text.split("T")[0];
      return text;
    },
    //个人，企业首页获取车险活动信息
    async homePageGetCarSafeActivityInfo() {
      var data = {
        data: {},
      };
      const res = await homePageGetCarSafeActivityInfo(data);
      if (res.code == 0) {
        for (var i in res.data) {
          if (res.data[i].activityType == 0) {
            this.Individual = res.data[i];
            this.Reservation = res.data[i].onOrOff;
          } else {
            this.GroupBuying = res.data[i];
          }
        }
      }
    },
    // 返回活动
    handelReturn() {
      this.$router.push({
        path: "/events",
      });
    },
    // 活动 切换个人/拼团：重新拉活动信息，取当前 tab 对应活动的开启/关闭状态
    async handelSelect(num) {
      await this.homePageGetCarSafeActivityInfo();
      if (num == "0") {
        this.Reservation = this.Individual.onOrOff;
      } else {
        this.Reservation = this.GroupBuying.onOrOff;
      }
      this.select = num;
    },
  },
};
</script>
<style lang="less" scoped>
.main {
  // 主体
  .Core-body {
    width: 100%;
    min-height: 600px;
    background: #ffffff;
    box-shadow: 0px 0px 10px 0px rgba(125, 125, 125, 0.5);
    border-radius: 20px;
    margin-top: 20px;
    margin-bottom: 20px;
    display: flex;
    flex-direction: column;
    // 主体内容
    .Main-body {
      height: 100%;
      margin: 30px 30px 30px 40px;
      // 切换
      .Toggle {
        width: 100%;
        min-height: 35px;
        display: flex;
        align-items: flex-end;
        color: #333333;
        text-align: center;
        font-weight: 400;
        margin-bottom: 30px;
        p:nth-child(1) {
          margin-left: 20px;
        }
        p {
          margin-right: 60px;
          font-size: 16px;
          cursor: pointer;
          box-sizing: border-box;
          border-bottom: 5px solid transparent;
        }
        .select-p {
          color: #409eff ;
          border-bottom-color: #409eff ;
        }
      }
      // 活动
      .ActivityCon {
        width: 100%;
        min-height: 20px;
        line-height: 20px;
        margin-top: 15px;
        font-family: PingFangSC-Medium;
        font-size: 14px;
        color: #666666;
        letter-spacing: 1px;
        font-weight: 400;
        display: flex;
        .EventsCon {
          flex: 1;
          /deep/ img {
            max-width: 200px;
            max-height: 200px;
            width: auto;
            height: auto;
            object-fit: contain;
            vertical-align: top;
          }
        }
      }
      // 活动
      .Events {
        height: 20px;
        line-height: 20px;
        font-family: PingFangSC-Medium;
        font-size: 12px;
        color: #666666;
        letter-spacing: 1px;
        line-height: 20px;
        font-weight: 400;
        margin-top: 15px;
      }
      // 表单
      .form-body {
        width: 100%;
        min-height: 300px;
        margin-top: 30px;
      }
    }
  }
}
/deep/.el-form-item__label {
  font-size: 12px;
}
</style>
